module.exports = __webpack_public_path__ + "static/cetmen-sm-04e414167b9f6f02af86216291dc4e7c.jpg";